import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ItemsLoading from '../../../../components/Loaders/ItemsLoading'
import SkeletonListRow from '../../../../features/components/List/Skeleton'
import PageSection from '../../../../features/components/PageSection'
import List from '../../../../features/components/List'

import { selectedPartnershipSelector } from '../../../../modules/selectors/partnerships'
import { clearTikTokCustomAudiences, getTikTokCustomAudiences } from '../../../../modules/actions/tikTokConstants'

import useCommonStyles from '../../../../styles/common/listPage'
import {
  tikTokCustomAudiencesErrorSelector,
  tikTokCustomAudiencesIsLoadingSelector,
  tikTokCustomAudiencesSelector,
  tikTokCustomAudiencesWasLoadedSelector
} from '../../../../modules/selectors/tikTokConstants'

import { commonColumns } from '../commonColumns'

const TikTokAudienceTable = () => {
  const dispatch = useDispatch()
  const commonClasses = useCommonStyles()

  const tikTokCustomAudiences = useSelector(tikTokCustomAudiencesSelector)

  const formattedTiktokAudiences = useMemo(() => {
    return tikTokCustomAudiences.map(audience => ({
      // tiktok audiences don't have 'id' field, but have 'audience_id' instead.
      // List component needs 'id' field to work properly
      id: audience.audience_id,
      ...audience
    }))
  }, [tikTokCustomAudiences])

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const tiktokAdAccountId = selectedPartnership?.tiktok_ad_account?.external_id

  const listSkeletonProps = useMemo(() => ({ cols: commonColumns }), [])

  useEffect(() => {
    dispatch(getTikTokCustomAudiences({ account: tiktokAdAccountId }))

    return () => {
      dispatch(clearTikTokCustomAudiences())
    }
  }, [dispatch, tiktokAdAccountId])

  return (
    <ItemsLoading
      className={commonClasses.itemList}
      itemsLength={formattedTiktokAudiences.length}
      SkeletonComponent={SkeletonListRow}
      skeletonProps={listSkeletonProps}
      errorSelector={tikTokCustomAudiencesErrorSelector}
      isLoadingSelector={tikTokCustomAudiencesIsLoadingSelector}
      wasLoadedSelector={tikTokCustomAudiencesWasLoadedSelector}
      ContentWrapper={PageSection}
    >
      <List
        cols={commonColumns}
        listData={formattedTiktokAudiences}
        Skeleton={<SkeletonListRow {...listSkeletonProps} />}
      />
    </ItemsLoading>
  )
}

export default TikTokAudienceTable
